<template>
  <div class="mb-4 relative car">
    <div class="relative flex justify-between gap-0 bg-white border rounded-xl border-menu-b hover:!shadow-xl transition-shadow ease-in-out duration-300">
      <div class="py-4 w-full md:py-6 md:px-6 md:flex md:gap-4 xl:gap-6 md:justify-between">
        <div class="hidden md:block">
          <div class="image-with-tags relative text-center text-white cursor-pointer md:max-w-[215px] xl:w-full" :class="{ 'xl:max-w-[362px]': isSubscriptionPage, 'xl:max-w-[300px]': !isSubscriptionPage}">
            <div :id="`products-images-${car.id}`" @click="openImageModal" >
              <div>
                  <div v-if="car.images.length === 0">
                    <img loading="lazy" class="w-full aspect-ratio-362-265 rounded-lg" src="/img/sub_car_placeholder_new.png" alt="">
                  </div>
                  <template v-for="(image, key) in sortedCarImages.slice(0,1)">
                    <img loading="lazy" class="w-full aspect-ratio-362-265 rounded-lg" :src="image.thumb" @error="replaceByDefault" alt="">
                  </template>
              </div>
            </div>
            <a v-if="!isSubscriptionPage" class="flex gap-1.5 text-[13px] items-center text-light-blue-2 my-3" href="javascript:void(0)" @click="showModal('my_information', car, sendEvent)">
              <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.5 2.46655C5.90496 2.46655 2.16663 6.20489 2.16663 10.7999C2.16663 15.3949 5.90496 19.1332 10.5 19.1332C15.095 19.1332 18.8333 15.3949 18.8333 10.7999C18.8333 6.20489 15.095 2.46655 10.5 2.46655ZM10.5 17.4666C6.82413 17.4666 3.83329 14.4757 3.83329 10.7999C3.83329 7.12405 6.82413 4.13322 10.5 4.13322C14.1758 4.13322 17.1666 7.12405 17.1666 10.7999C17.1666 14.4757 14.1758 17.4666 10.5 17.4666Z" fill="#545D78"></path>
                <path d="M9.66663 9.96663H11.3333V14.9666H9.66663V9.96663ZM9.66663 6.6333H11.3333V8.29997H9.66663V6.6333Z" fill="#545D78"></path>
              </svg>
              <p class="border-b border-light-blue-2">
                {{ $t('layout.filters.important_information') }}
              </p>
            </a>
            <div class="top-left absolute left-2 top-2">
              <ul class="flex flex-wrap gap-1" v-if="car.tags.length">
                <li class="rounded-sm font-semibold text-white text-center bg-[#A9BD2F] text-[10px] py-[2px] px-[6px]"
                    v-for="(tag, key) in car.tags" :key="key" :class="tag.color">{{ $t(`car.tags.${tag.label}`) }}</li>
              </ul>
            </div>
            <dialog v-if="car.images.length != 0" class="modal px-3 hidden" :id="'car_modal_'+car.id">
              <div class="modal-box modal_car_popup md:!max-w-[900px] !max-h-full !w-full !max-w-full !rounded-xl !p-0">
                <div :class="['products-images-popup', car.images.length > 1 ? 'products-images-slider' : '']" :id="'products-images-popup-' + car.id">
                  <template v-for="(image, key) in sortedCarImages">
                    <div>
                      <img loading="lazy" class="w-full" :src="image.main" @error="replaceByDefault">
                    </div>
                  </template>
                </div>
              </div>
              <form class="modal-backdrop" method="dialog">
                <button><i class="fa-solid fa-xmark text-xl"></i></button>
              </form>
            </dialog>
          </div>
        </div>
        <div class="border-r md:w-[272px] border-[#D9DBE1] xl:w-full " :class="{ 'xl:max-w-[336px]': isSubscriptionPage, 'xl:max-w-[417px]': !isSubscriptionPage}" @click.prevent="showMoreInfo(car, prevCar, nextCar, sendEvent)">
          <div class="flex justify-between pl-4 pr-3 lg:block md:pl-0">
            <div class="relative"><span class="text-xs pb-1 font-medium text-[#84889A] leading-[14px]">{{ car.type.name[appLocale] }}</span>
              <h3 class="text-dark-blue-2 pb-2 font-bold text-[21px] leading-[26px]">
                <ais-highlight attribute="brand.name" :hit="car"></ais-highlight>&nbsp;
                <ais-highlight attribute="model.name" :hit="car"></ais-highlight>
              </h3>
              <span class="w-8 h-8 rounded-full border-2 border-lime-500 inline-flex ml-4 absolute right-0 top-0 hidden lg:bl">
                <span class="bg-lime-500 rounded-full w-full h-full text-sm font-bold border-2 text-white border-white justify-center items-center inline-flex">4</span>
              </span>
              <span class="location flex text-sm items-center gap-2 text-dark-blue-2 " :class="{'mb-1': !isSubscriptionPage, 'font-medium': isSubscriptionPage}">
                <span>
                  <img :src="versionAsset('/assets/shared/img/icons/location-pin.svg')" alt="location-pin">
                </span>{{ getClosestDepartment(car).name[appLocale] }}
              </span>
              <span class="location-map flex text-sm items-center gap-2 text-dark-blue-2 font-normal mb-1" v-if="!isSubscriptionPage && car.distanceFromClosestLocation >= 0.1">
                <span><img src="/assets/customer-v3/img/pin-distance-line.svg" alt="location-pin"></span>
                {{ $t('layout.distance_away_from_department', { km: car.distanceFromClosestLocation, department: postal, distanceUnitShort: distanceUnitShort }) }}
              </span>
            </div>
            <div class="w-28 rounded-lg md:hidden" v-if="car.images.length > 0">
              <img loading="lazy" class="w-28 rounded-lg" :src="car.images[0].thumb" @error="replaceByDefault"  >
            </div>
            <div class="w-28 rounded-lg md:hidden" v-else>
              <img loading="lazy" class="w-28 rounded-lg" src="/img/sub_car_placeholder_new.png" >
            </div>
          </div>
          <div class="border-t border-b py-3 px-5 mt-2 border-[#D9DBE1] md:pl-0">
            <ul class="flex items-center gap-y-3 flex-wrap gap-4 max-lg:gap-3" v-if="car.transmission_original || car.seats || car.fuel_type_original">
              <li v-if="car.seats" class="text-sm text-dark-blue-2 font-medium leading-4 flex items-center gap-1 md:w-auto">
                <img :src="versionAsset('/assets/shared/img/icons/avtar.svg')" alt="avtar">
                {{ car.seats + ' ' + $t('inputs.car.seats') }}
              </li>
              <li v-if="car.fuel_type_original" :class="['text-sm', 'leading-4', 'flex', 'items-center', 'gap-1', 'md:w-auto', car.fuel_type_original != 'electric' ? 'text-dark-blue-2 font-medium' : 'font-semibold text-[#00AEB9]' ]">
                <img v-if="car.fuel_type_original !== 'electric'" :src="versionAsset('/assets/shared/img/icons/diesel.svg')" >
                <img v-else :src="versionAsset('/assets/shared/img/icons/electric-icon.svg')" class="xl:w-6">
                {{ $t('admin.labels.'+car.fuel_type_original) || '-' }}
              </li>
              <li v-if="car.transmission_original" class="text-sm text-dark-blue-2 font-medium leading-4 flex items-center gap-1 md:w-auto">
                <img :src="versionAsset('/assets/shared/img/icons/automatic.svg')" alt="transmission">
                {{ $t('admin.labels.' + car.transmission_original) || '-' }}
              </li>
              <li v-if="car.mileage" :class="['text-sm', 'leading-4', 'flex', 'items-center', 'gap-1', 'md:w-auto', car.fuel_type_original != 'electric' ? 'text-dark-blue-2 font-medium' : 'font-semibold text-[#00AEB9]' ]">
                <img :src="car.fuel_type_original != 'electric' ? versionAsset('/assets/subscription/img/km-icon.svg') : versionAsset('/assets/subscription/img/km-blue-icon.svg')" alt="km-icon">
                {{ car.mileage }} {{ car.fuel_type_original != 'electric' ? carMileageUnits : $t('layout.labels.km_range', {distanceUnitShort: distanceUnitShort }) }}
              </li>
              <li v-if="car.doors" class="text-sm text-dark-blue-2 font-medium leading-4 flex items-center gap-1 md:w-auto">
                <img :src="versionAsset('/assets/shared/img/icons/doors.svg')" alt="doors">
                {{ car.doors + ' ' + $t('inputs.car.doors') }}
              </li>
              <li v-if="car.has_tow_hook" class="text-sm text-dark-blue-2 font-medium leading-4 flex items-center gap-1 md:w-auto">
                <img :src="versionAsset('/assets/shared/img/icons/towhook.svg')" alt="features">
                {{ $t('layout.labels.with_tow_hook') }}
              </li>
              <li v-if="!car.has_tow_hook" class="text-sm text-dark-blue-2 font-medium leading-4 flex items-center gap-1 md:w-auto">
                <img :src="versionAsset('/assets/shared/img/icons/no-towhook.svg')" alt="features">
                {{ $t('layout.labels.no_towbar') }}
              </li>
            </ul>
          </div>
          <div class="border-b py-3 px-5 border-[#D9DBE1] md:pl-0" v-if="isSubscriptionPage">
            <p class="text-sm font-normal leading-4 text-date">{{ $t('layout.labels.subscription.available_from') }} <span class="font-semibold !text-[#208E00]">{{ formatDate(getAvailableFrom(car)) }}</span></p>
          </div>
          <div class="pt-3 px-5 flex justify-between items-center gap-2 md:pl-0" v-if="!isSubscriptionPage && !hideBookingTime">
            <div class="relative flex flex-wrap gap-4">
              <p class="text-sm leading-4 text-dark-blue-2 flex gap-1" v-if="!isSubscriptionPage && !hideBookingTime">
                <span class="font-normal">{{ $t('layout.filters.pickup_time') }}</span>
                <span class="font-semibold">
                  <template v-if="getCarInfo(car.id).default_pickup_time">
                    {{ getCarInfo(car.id).default_pickup_time }}
                  </template>
                  <template v-else-if="allowLocationWorkHoursBreaks && getCarInfo(car.id).pickup_break_start && getCarInfo(car.id).pickup_break_end">
                    {{ getCarInfo(car.id).pickup_time_min }} – {{ getCarInfo(car.id).pickup_break_start }}, {{ getCarInfo(car.id).pickup_break_end }} - {{ getCarInfo(car.id).pickup_time_max }}
                  </template>
                  <template v-else>
                    {{ getCarInfo(car.id).pickup_time_min }} – {{ getCarInfo(car.id).pickup_time_max }}
                  </template>
                  </span>
              </p>
              <p class="text-sm leading-4 text-dark-blue-2 flex gap-1" v-if="!isSubscriptionPage && !hideBookingTime">
                <span class="font-normal">{{ $t('layout.filters.delivery_time') }} </span>
                <span class="font-semibold">
                  {{ $t('customer_booking_process.side_panel.latest_at') }}
                    <template v-if="getCarInfo(car.id).default_delivery_time">
                    {{ getCarInfo(car.id).default_delivery_time }}
                    </template>
                    <template v-else>
                      {{ getCarInfo(car.id).delivery_time_min }}
                    </template>
                  </span>
              </p>
            </div>
          </div>
          <div class="pt-3 px-5 flex justify-between items-center gap-2 md:pl-0">
            <div class="relative" :class="{'flex flex-wrap gap-4' : !isSubscriptionPage}" v-if="isSubscriptionPage">
              <p class="text-sm leading-4 font-normal text-dark-blue-2" v-if="isSubscriptionPage">{{ $t('layout.labels.subscription.commitments') }} <span class="text-date text-sm leading-4 font-semibold">{{ getCommitments(car) }}</span></p>
            </div>
            <div v-if="!isSubscriptionPage && getCarInfo(car.id).days_discount" class="relative md:hidden">
              <p class="text-left flex mb-2 text-xs text-[#208E00] bg-[#DCFCD8] leading-[1.2]  gap-1 py-2 px-2.5 max-w-[120px] mobile-disc-arrow">
                <svg class="!w-6" width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.04292 13.6094C8.7801 13.8722 8.46307 14.0036 8.09182 14.0036C7.72056 14.0036 7.40353 13.8722 7.14072 13.6094L0.890717 7.35937C0.748206 7.21686 0.64965 7.06565 0.59505 6.90574C0.540472 6.74584 0.513184 6.57724 0.513184 6.39994V1.33327C0.513184 0.956462 0.639028 0.640634 0.890717 0.38579C1.14242 0.130957 1.45667 0.00354004 1.83348 0.00354004H6.90015C7.07745 0.00354004 7.25161 0.0324064 7.42262 0.0901398C7.59364 0.147873 7.75041 0.247996 7.89292 0.390507L14.1096 6.59776C14.3835 6.87167 14.5204 7.19582 14.5204 7.57022C14.5204 7.94462 14.3835 8.26878 14.1096 8.54271L9.04292 13.6094ZM8.1429 12.6999L13.2096 7.63327L6.90015 1.33327H1.83348V6.39994L8.1429 12.6999ZM3.58348 3.93327C3.81682 3.93327 4.01959 3.84716 4.19182 3.67494C4.36404 3.50272 4.45015 3.29994 4.45015 3.06661C4.45015 2.83327 4.36404 2.6305 4.19182 2.45827C4.01959 2.28605 3.81682 2.19994 3.58348 2.19994C3.35015 2.19994 3.14737 2.28605 2.97515 2.45827C2.80293 2.6305 2.71682 2.83327 2.71682 3.06661C2.71682 3.29994 2.80293 3.50272 2.97515 3.67494C3.14737 3.84716 3.35015 3.93327 3.58348 3.93327Z" fill="#208E00"></path>
                </svg>
                <span class="font-semibold whitespace-pre-line">{{ $t('layout.filters.consecutive_discount', {discount: getCarInfo(car.id).days_discount}) }}</span>
              </p>
            </div>
            <div v-if="!isSubscriptionPage" class="relative md:hidden ml-auto">
              <div class="text-xs !text-dark-blue-2 flex md:hidden flex-col items-end">
                <p v-if="getCarInfo(car.id).days_discount" class="text-sm text-light-blue-2 font-normal text-right line-through leading-[16.8px]">{{ formatPrice(Math.round(getCarTotalAmount(car, 'rental') - getCarInfo(car.id).days_discount_amount)) }}</p>
                <p class="text-sm tetx-dark-blue-2 text-right flex flex-col items-end"><span class="pr-1 font-bold text-[21px] !leading-7">{{ formatPrice(getCarTotalAmount(car, 'rental')) }} </span>&nbsp;{{ $t('layout.subscription.total')}}</p>
              </div>
              <template v-if="getCarInfo(car.id).is_long_booking">
                <p class="text-xs text-light-blue-2 font-medium text-right leading-[16.8px] md:hidden mt-1">{{ $t('layout.filters.price_per_day', { price: formatPrice(car.long_term_day_price) }) }}</p>
              </template>
              <template v-else>
                <p class="text-xs text-light-blue-2 font-medium text-right leading-[16.8px] md:hidden mt-1">{{ $t('layout.filters.price_per_day', { price: formatPrice(getCarInfo(car.id).average_price_per_day) }) }}</p>
              </template>
            </div>
            <div class="text-xs !text-dark-blue-2 md:hidden" v-if="isSubscriptionPage">
              <p>{{ $t('layout.subscription.from') }}<span class="pl-1 font-bold text-[22px] !leading-7">{{formatPrice(getCarTotalAmount(car))}}</span></p><span class="text-right block">{{ $t('layout.subscription.price_per_month') }}</span>
            </div>
          </div>
          <div class="electric-tag mt-2 mr-5 block md:hidden" v-if="car.tags.length">
            <ul class="flex flex-wrap gap-1 justify-end">
              <li v-for="(tag, key) in car.tags" :key="key" :class="`bg-[${tag.color}]` + ' rounded-md font-semibold text-white text-cente text-xs bg- py-[5px] px-[9px]'" >{{ $t(`car.tags.${tag.label}`) }}</li>
            </ul>
          </div>
        </div>
        <div class="hidden items-end flex-col justify-center hover-btn-orange md:flex" @click.prevent="showMoreInfo(car, prevCar, nextCar, sendEvent)">
          <p class="whitespace-nowrap flex items-center mb-2 text-xs text-[#208E00] bg-[#DCFCD8] leading-6  gap-1 py-2 px-2.5 extra-disc-arrow" v-if="!isSubscriptionPage && getCarInfo(car.id).days_discount">
            <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.04292 13.6094C8.7801 13.8722 8.46307 14.0036 8.09182 14.0036C7.72056 14.0036 7.40353 13.8722 7.14072 13.6094L0.890717 7.35937C0.748206 7.21686 0.64965 7.06565 0.59505 6.90574C0.540472 6.74584 0.513184 6.57724 0.513184 6.39994V1.33327C0.513184 0.956462 0.639028 0.640634 0.890717 0.38579C1.14242 0.130957 1.45667 0.00354004 1.83348 0.00354004H6.90015C7.07745 0.00354004 7.25161 0.0324064 7.42262 0.0901398C7.59364 0.147873 7.75041 0.247996 7.89292 0.390507L14.1096 6.59776C14.3835 6.87167 14.5204 7.19582 14.5204 7.57022C14.5204 7.94462 14.3835 8.26878 14.1096 8.54271L9.04292 13.6094ZM8.1429 12.6999L13.2096 7.63327L6.90015 1.33327H1.83348V6.39994L8.1429 12.6999ZM3.58348 3.93327C3.81682 3.93327 4.01959 3.84716 4.19182 3.67494C4.36404 3.50272 4.45015 3.29994 4.45015 3.06661C4.45015 2.83327 4.36404 2.6305 4.19182 2.45827C4.01959 2.28605 3.81682 2.19994 3.58348 2.19994C3.35015 2.19994 3.14737 2.28605 2.97515 2.45827C2.80293 2.6305 2.71682 2.83327 2.71682 3.06661C2.71682 3.29994 2.80293 3.50272 2.97515 3.67494C3.14737 3.84716 3.35015 3.93327 3.58348 3.93327Z" fill="#208E00"></path>
            </svg>
            <span class="font-semibold">{{ $t('layout.filters.consecutive_discount', {discount: getCarInfo(car.id).days_discount}) }}</span>
          </p>
          <div class="relative">
            <div class="text-xs !text-dark-blue-2 flex mt-1 mb-3 flex-col items-end">
              <p v-if="!isSubscriptionPage && getCarInfo(car.id).days_discount" class="text-sm text-light-blue-2 font-normal text-right line-through leading-[16.8px] flex flex-col items-start">
                {{ formatPrice(Math.round(getCarTotalAmount(car, 'rental') - getCarInfo(car.id).days_discount_amount)) }}
              </p>
              <div class="flex flex-col" :class="{'items-center mb-4': isSubscriptionPage}">
                <p class="text-sm text-dark-blue-2 text-right" :class="{'flex flex-col items-end': isSubscriptionPage}">
                  <template v-if="isSubscriptionPage">
                    {{ $t('layout.subscription.from') }}
                    <span class="!text-[22px] !font-bold !leading-[29px]" id="prices">{{formatPrice(getCarTotalAmount(car))}}</span>
                  </template>
                  <template v-else>
                    <span class="!text-[22px] !font-bold !leading-[29px]" id="prices">{{ formatPrice(getCarTotalAmount(car, 'rental')) }}</span>
                    {{ $t('layout.subscription.total')}}
                  </template>
                </p>
                <p v-if="isSubscriptionPage" class="text-sm text-dark-blue-2 font-medium text-right leading-[16.8px]"> {{ $t('layout.subscription.price_per_month') }}</p>
              </div>
            </div>
            <p class="text-xs text-light-blue-2 font-medium text-right leading-[16.8px] mt-1" v-if="!isSubscriptionPage">
              <template v-if="getCarInfo(car.id).is_long_booking">
                {{ $t('layout.filters.price_per_day', { price: formatPrice(car.long_term_day_price) }) }}
              </template>
              <template v-else>
                {{ $t('layout.filters.price_per_day', { price: formatPrice(getCarInfo(car.id).average_price_per_day) }) }}
              </template>
            </p>
          </div>
          <button class="button-orange lg:!w-[125px] !w-[165px] xl:w-full xl:max-w-[178px] mt-5" :class="{'xl:!w-[170px]': isSubscriptionPage}">{{ $t('layout.subscription.select_car') }}</button>
        </div>

      </div>
      <button class="text-md md:hidden to-button-car-landscape from-[#FF792E] via-[#FE660C] to-[#FE660C]" @click.prevent="showMoreInfo(car, prevCar, nextCar, sendEvent)"><i class="fa-solid fa-angle-right"></i></button>
    </div>
  </div>
</template>
<script>
import {
  AisHighlight,
} from 'vue-instantsearch/vue3/es';

export default {
  name: 'CarLandscape',
  props: {
    car: {
      type: Object,
      required: true,
    },
    prevCar: {
      type: Number,
      required: false,
    },
    nextCar: {
      type: Number,
      required: false,
    },
    appLocale: {
      type: String,
      required: true
    },
    postal: {
      type: String,
      required: true,
    },
    getCarTotalAmount: {
      type: Function,
      required: true,
    },
    getClosestDepartment: {
      type: Function,
      required: true,
    },
    getDepartmentCarsCount: {
      type: Function,
      required: true,
    },
    showMoreInfo: {
      type: Function,
      required: true,
    },
    formatDayPrices: {
      type: Function,
      required: true,
    },
    replaceByDefault: {
      type: Function,
      required: true,
    },
    getCommitments: {
      type: Function,
      required: true,
    },
    isDefaultSort: {
      type: Function,
      required: true,
    },
    getAvailableFrom: {
      type: Function,
      required: true,
    },
    initSlider: {
      type: Function,
      required: true,
    },
    isSubscriptionPage: {
      type: Boolean,
      required: true,
    },
    hideBookingTime: {
      type: Boolean,
      required: false,
    },
    getCarInfo: {
      type: Function,
      required: true
    },
    showModal: {
      type: Function,
      required: true
    },
    sendEvent: {
      type: Function,
      required: true
    },
  },
  components: {
    AisHighlight,
  },
  data() {
    return {
      carMileageUnits: window.carMileageUnits,
      distanceUnitShort: window.distanceUnitShort,
      allowLocationWorkHoursBreaks: window.allowLocationWorkHoursBreaks,
    };
  },
  computed: {
    csrf_token() {
      return $('[name="csrf-token"]').attr('content');
    },
    sortedCarImages() {
        if (!this.car || !this.car.images) {
          return [];
        }

        const priority = {
          main: 1,
          second: 2,
          front: 3,
          right_side: 4,
          left_side: 5,
          back: 6,
          driver_cabin: 7,
          passenger_cabin: 8,
          trunk: 9,
          other: 10,
          unset: 11,
        };

        return this.car.images.slice().sort((a, b) => {

          const prioA = priority[a.image_place] || 99;
          const prioB = priority[b.image_place] || 99;

          if (prioA !== prioB) {
            return prioA - prioB;
          }

          const orderA = a.image_order !== undefined ? a.image_order : Infinity;
          const orderB = b.image_order !== undefined ? b.image_order : Infinity;

          return orderA - orderB;
        });
      }
  },
  mounted() {
    $("a.show_more_btn").click(function(){
      $("#all-show-feature li.show-content").toggleClass("hidden");
      var isHidden = $("#all-show-feature li.hidden").length > 0;
      var text = isHidden ? "Show all features" : "Show less";
      var iconClass = isHidden ? "fa-chevron-down" : "fa-chevron-up";
      $("a.show_more_btn").html(text + '<i class="fa-solid ' + iconClass + ' ml-1"></i>');
    });

    $('.other-departments-search-alert').slice(1).remove();
    $('.future-search-alert').slice(1).remove();
    $('.less-cars-alert').slice(1).remove();
  },
  methods: {
    openImageModal() {
      this.initSlider(`#car_modal_${this.car.id} .products-images-slider`);
      this.showModal("car_modal_" + this.car.id);
    },
  },
}
</script>
